import React, { useEffect, useRef, useState } from "react";
import {
  IOptionalModifier,
  IBucketSelectedIngredients,
} from "../../../../models/try2Combo";
import * as Constants from "../../../../constants";
import RequiredModifier from "./ingredients/RequiredModifier";
import { itemBuckets } from "../../../../priceCalculation/buckets";
import { ADDITIONAL_ADDED } from "../../../../priceCalculation/constants";
import { ICoreModifiers, IModifierGroups } from "../../../../models/item.model";
import { IParams } from "../../../../models/card";
import CoreModifiers from "./ingredients/CoreModifiers";
import ModifierGroups from "./ingredients/ModifierGroups";
import { Scrollbars } from "react-custom-scrollbars";
import { filterArraysBasedOnGroupId } from "../../../../helpers/customizedItem/customizedItem.helper";
import { isItCreateYourOwnItem } from "../../../../helpers/helperMethods";

const AddIngredients: React.FC<IOptionalModifier> = (props) => {
  const {
    coreModifiers,
    modifierGroups,
    requiredModifiers,
    handleIngredientSelection,
    sectionSelected,
    noDressingHandler,
    itemName,
    isItEdit,
    is_create_your_own,
    openAccordionFor
  } = props;

  const handleCoreModifierClick = (
    data: IParams,
    modifier: ICoreModifiers,
    type: string
  ) => {
    handleIngredientSelection({
      ...data,
      ...{
        modifier_group_id: modifier?.modifier_group_id,
        modifier_type: type,
      },
    });
  };

  const handleClick = (
    data: IParams,
    modifierGroup: IModifierGroups,
    type: string
  ) => {
    handleIngredientSelection({
      ...data,
      ...{
        modifier_group_id: modifierGroup?.id,
        modifier_group_max: modifierGroup?.max,
        modifier_group_base: modifierGroup?.base,
        modifier_type: type,
      },
    });
  };

  const selectedAddOns = (function () {
    return itemBuckets.specificItemBucketSelectedModifiers(
      Constants.ADD_ONS,
      sectionSelected
    );
  })();

  const selectedCore: IBucketSelectedIngredients[] = (function () {
    return itemBuckets.specificItemBucketSelectedModifiers(
      Constants.CORE_MODIFIERS,
      sectionSelected
    );
  })();

  const selectedAddedAddOns: IBucketSelectedIngredients[] = (function () {
    const fromItem: 0|1 = parseInt(sectionSelected) - 1 as 0|1;
    return itemBuckets.getSingleBucketKeyValue(
      {name:Constants.ADD_ONS,
      fromItem,
      modifierType:ADDITIONAL_ADDED,
      key:"modifiers"}
    );
  })();

  const coreModifierBucket = (function () {
    return itemBuckets.getSingleBucket(
      {name:Constants.CORE_MODIFIERS,
      fromItem:parseInt(sectionSelected)}
    );
  })();

  const isItCoreRelated = (groupId: number) => {
    if (coreModifierBucket["memoryChip"]) {
      const isExist = coreModifierBucket["memoryChip"][groupId];
      if (isExist === undefined) {
        return false;
      } else {
        return true;
      }
    }
  };

  const isLimitExceed = (groupId: number, extendable_limit: number, groupMin) => {
    if(extendable_limit === 1 && groupMin === 1){
      return false;
    } else {
      if (!isItCoreRelated(groupId)) {
        const selectedModifierForCurrentGroup:IBucketSelectedIngredients[] = filterArraysBasedOnGroupId([selectedAddedAddOns],groupId)
        return selectedModifierForCurrentGroup.length >= extendable_limit ? true : false;
      } else {
        if (coreModifierBucket["memoryChip"][groupId]?.changes) {
          return coreModifierBucket["memoryChip"][groupId]?.changes?.quantity >=
            extendable_limit
            ? true
            : false;
        } else {
          return coreModifierBucket["memoryChip"][groupId]?.quantity >=
            extendable_limit
            ? true
            : false;
        }
      }
    }
  };

  return (
    <div className="other-dressing-view try2_dressing_modal px-lg-5 px-md-0">
      <Scrollbars className="Modal_inner_scrollbar customization_inner_scrollbar apply-btn-view">
        {coreModifiers?.length ? <CoreModifiers
          coreModifiers={coreModifiers}
          selectedCore={selectedCore}
          handleCoreModifierClick={handleCoreModifierClick}
          isLimitExceed={isLimitExceed}
          openFirstAccordion = {openAccordionFor.current === Constants.CORE_MODIFIERS}
        />: null}
        {requiredModifiers?.length ? <RequiredModifier
          sectionSelected={sectionSelected}
          itemIngredients={requiredModifiers}
          handleIngredientSelection={handleIngredientSelection}
          noDressingHandler={noDressingHandler}
          showMaxSelection={isItCreateYourOwnItem(is_create_your_own) ? false : true}
          // customizationModule={true}
          showAdditionalPrice={true}
          openFirstAccordion = {openAccordionFor.current === Constants.REQUIRED_MODIFIERS}
        /> : null}
        {modifierGroups?.length ? <ModifierGroups
          modifierGroups={modifierGroups}
          selectedAddOns={selectedAddOns}
          selectedCore={selectedCore}
          handleClick={handleClick}
          isLimitExceed={isLimitExceed}
          isItEdit={isItEdit}
          openFirstAccordion = {openAccordionFor.current === Constants.ADD_ONS}
        />: null}
      </Scrollbars>
    </div>
  );
};

export default AddIngredients;
